import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function Offer() {
  return <Section alt className="text-center pb-12" data-id="element-92">
      <FadeIn data-id="element-93">
        <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-94">
          Empieza hoy por 20 minutos.
        </h2>

        <div className="bg-white inline-block px-3 py-1 rounded-full mb-8 border border-border shadow-sm" data-id="element-95">
          <p className="text-xs font-semibold text-charcoal" data-id="element-96">
            +4.500 copias descargadas.
          </p>
        </div>

        <div className="max-w-[280px] mx-auto mb-10" data-id="element-97">
          <img src="https://cdn.magicpatterns.com/uploads/nqBTePU6cNpRofTmQfaMSk/elpermiso.png" alt="El Permiso — Manual de recuperación de identidad parental" className="w-full rounded-xl shadow-[0_6px_20px_rgba(0,0,0,0.06)] object-cover" data-id="element-98" />
        </div>

        <div className="text-4xl md:text-5xl font-bold text-navy mb-8" data-id="element-99">
          7€{' '}
          <span className="text-xl md:text-2xl text-gray font-medium align-middle" data-id="element-100">
            · pago único
          </span>
        </div>

        <div className="max-w-sm mx-auto mb-6" data-id="element-101">
          <CTAButton data-id="element-102" />
        </div>

        <p className="text-sm text-gray max-w-sm mx-auto" data-id="element-103">
          Compra privada: sin comunidad, sin comentarios, sin exposición.
        </p>
      </FadeIn>
    </Section>;
}